let formEl;

function init() {
  formEl = document.getElementById('orderForm');
  if (!formEl) { return; }

  initPriceCalcs();
  initSubmissionHandler();
  initQuantitiesFromCart();
}

function initPriceCalcs() {
  getQuantityEls().forEach(quantEl => {
    quantEl.addEventListener('change', () => recalcLinePrice(quantEl));
    recalcLinePrice(quantEl);
  });
}

function recalcLinePrice(el) {
  const lineEl = el.closest('.orderLine');
  const quantityEl = lineEl.querySelector('.orderLine__quantityWrap input');
  const priceCents = Number.parseInt(quantityEl.dataset.productPrice);
  const quantity = Number.parseInt(quantityEl.value);
  
  const lineTotal = quantity * priceCents;
  const totalStr = stringFromCents(lineTotal);
  const priceEl = lineEl.querySelector('.orderLine__linePrice');
  priceEl.textContent = totalStr;
  priceEl.dataset.totalCents = lineTotal;
  recalcTotal();
}

function recalcTotal() {
  // Sum all cents from the input
  const linePriceEls = Array.from(formEl.querySelectorAll('.orderLine__linePrice'));
  const totalCents = linePriceEls.reduce(function(sum, priceEl) {
    return sum + Number.parseInt(priceEl.dataset.totalCents);
  }, 0);

  const totalStr = stringFromCents(totalCents);
  formEl.querySelector('.orderForm__total').textContent = totalStr;
}

function stringFromCents(totalCents) {
  const dollars = Math.floor(totalCents / 100);
  const cents = (totalCents % 100);
  const centsStr = cents.toString().padStart(2, '0');
  
  return '$' + dollars + '.' + centsStr;
}

function initSubmissionHandler() {
  formEl.addEventListener('submit', (e) => {
    e.preventDefault();
    
    if (!validateOrAlert()) { return; }
    updateCart().then(() => window.location = window.Shopify.routes.root + 'cart');
  });
}

async function updateCart() {
  const quantities = getFormQuantities();
  const attributes = getAgreedToTags();
  const request = { updates: quantities };
  
  if (attributes.length) {
    request.attributes = { __localDeliveryTags: attributes.join(',') };
  }
  
  return fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(request)
  })
  .then(response => {
    return response.json();
  })
  .catch((error) => {
    console.error('Error:', error);
  })
}

function fetchCartQuantities() {
  const url = window.Shopify.routes.root + 'cart.js';
  return fetch(url)
    .then(response => response.json())
    .then(cart => {
      const quantities = {};

      cart.items.forEach(item => {
        quantities[item.variant_id.toString()] = Number.parseInt(item.quantity);
      });
      
      return quantities;
    });
}

/** @return Object { variantId => quantity } */
function getFormQuantities() {
  const result = {};
  
  getQuantityEls().forEach(quantityEl => {
    const variantId = quantityEl.dataset.variantId.toString();
    const quantity = Number.parseInt(quantityEl.value);
    result[variantId] = quantity;
  });
  
  return result;
}

function getAgreedToTags() {
  const checkedAgreements = Array.from(formEl.querySelectorAll('.orderForm__agreement .orderForm__agreementCheck:checked'));
  
  return checkedAgreements.filter(agreement => !!agreement.value)
    .map(agreement => agreement.value);
}

function getQuantityEls() {
  return formEl.querySelectorAll('.orderLine__quantityWrap input');
}

function validateOrAlert() {
  const hasUncheckedAgreement = !!formEl.querySelector('.orderForm__agreement .orderForm__agreementCheck:not(:checked)');

  // No unchecked agreements: We're good.
  if (!hasUncheckedAgreement) { return true; }
  
  alert("You must agree to all terms and conditions before continuing");
  return false;
}

async function initQuantitiesFromCart() {
  const cart = await fetchCartQuantities();
  const variantIds = Object.keys(cart);
  
  variantIds.forEach((variantId) => {
    const quantity = cart[variantId];
    
    // Quantities are already defaulted to zero
    if (!quantity) { return; }
    
    const quantityEl = formEl.querySelector(`.orderLine__quantityWrap input[data-variant-id="${ variantId }"]`);
    if (!quantityEl) { return; }
    
    quantityEl.value = quantity;
    recalcLinePrice(quantityEl);
  });
}

export default { init };